import { useEffect, useState } from "react";
import { Box, MenuItem } from "@mui/material";
import Select from "../../select/select";
import Typography from "../../typography/typography";
import { FieldSelectorProps } from "react-querybuilder";
import SearchBar from "../../search-bar/search-bar";
import "../filter.scss";
import formatText from "../../../utils/format-text";
import { useTranslation } from "react-i18next";

const FieldSelect = (props: FieldSelectorProps) => {

  const { t } = useTranslation();

  const { handleOnChange, value, options, ...rest } = props;

  const [filteredOptions, setFilteredOptions] = useState<any[]>();

  const handleSearchEvent = (searchText: string) => {
    const ops = options?.filter(o => Boolean(o.label?.trim())) || []
    const filteredData = ops.filter((option: any) =>
      option.name.toLowerCase().includes(searchText.toLowerCase()),
    );
    setFilteredOptions(filteredData);
  };

  useEffect(() => {
    setFilteredOptions(options?.filter(o => Boolean(o.label?.trim())) || [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[options?.length])


  return (
    <Box width="100%">
      <Select
        fullWidth
        value={value}
        onChange={(e: any) => handleOnChange(e.target.value)}
        {...rest}
        className="select-drps"
        variant="outlined"
        renderValue={(value: any) => formatText(t(filteredOptions?.find((opttion: any)=>opttion.name === value)?.label)?.replace("_id", '')?.replaceAll("_", " ") || "Select Default")}
        onClose={() => setFilteredOptions(options?.filter(o => Boolean(o.label?.trim())) || [])}
      >
        <div className="searchbar-box-list new-searchbar">
          <SearchBar
            placeholder={"Search Attributes"}
            handleSearch={(e) => handleSearchEvent(e)}
          />
        </div>
        {filteredOptions?.map((op: any) => (
          <MenuItem key={op.name} value={op.name}>
            <Typography type="s4" color="theme.secondary.1000">
              {formatText(t(op.label)?.replace("_id", '')?.replaceAll("_", " "))}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export { FieldSelect };
export default FieldSelect;
